import { useContext, useState } from 'react';
import Select from 'react-select';
import { Col, Form, Label, Row } from 'reactstrap';

import { useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import { customSelectStyleNew } from '../../components/styled/customSelect';
import {
  CANCEL,
  MODULE_ACCESS,
  SAVE,
} from '../../constants';
import { AppContext } from '../../context';
import { CHATGPTMODULE_OPTIONS, gptTemplateTagsArray } from '../../utils/constant';
import { ALL_LLM_MODELS, ALL_LLM_PROVIDERS, SAVE_CHATGPT_TEMPLATES } from './gql';
import CustomButton from '../../components/layout/CustomButton';

const AddModal = ({
  onClose,
  Controller,
  control,
  handleSubmit,
  refetchGPTTemplates,
  toggle
}) => {
  const { theme } = useContext(AppContext);
  const [saveChatgptTemplates, { loading: saveChatgptTemplatesLoading }] = useMutation(SAVE_CHATGPT_TEMPLATES);
  const [copied, setCopy] = useState<boolean>(false);
  const [selectedProvider, setSelectedProvider] = useState<any>(null);
  const [selectedModel, setSelectedModel] = useState<any>(null);
  const [description, setDescription] = useState<string>('');

  const { data: providersData } = useQuery(ALL_LLM_PROVIDERS);
  const { data: modelsData } = useQuery(ALL_LLM_MODELS, {
    variables: { providerId: selectedProvider?.value },
    skip: !selectedProvider,
  });

  const providerOptions = (providersData?.allLlmProviders ?? []).map((p: any) => ({
    label: p.displayName,
    value: p.id,
  }));

  const modelOptions = (modelsData?.allLlmModels ?? []).map((m: any) => ({
    label: m.displayName,
    value: m.id,
  }));

  const onCopyText = (item: string) => {
    navigator.clipboard.writeText(item);
    setCopy(true);
    setTimeout(() => setCopy(false), 1500);
  };

  const submitData = async (data) => {
    const settingsdata = {
      module: data?.module?.value,
      template: data?.template,
      description: description || undefined,
      modelId: selectedModel?.value || undefined,
    };
    const settingsResp = await saveChatgptTemplates({
      variables: { settingDetails: settingsdata }
    });

    if (settingsResp?.data?.SaveChatgptTemplates?.status === 200) {
      toast.success('LLM Prompt Template saved successfully');
      toggle();
      refetchGPTTemplates();
    }
  };

  return (
    <div className="p-4">
      <h4 className="mb-4">{MODULE_ACCESS}</h4>

      <Form>
        <Row className="mb-3">
          <Col md="12">
            <Label>Name (Module)</Label>
            <Controller
              control={control}
              name="module"
              options={CHATGPTMODULE_OPTIONS?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              render={({ field }) => (
                <Select
                  value={field.value ?? null}
                  options={CHATGPTMODULE_OPTIONS}
                  isSearchable={false}
                  placeholder="Select Module For Template"
                  onChange={(target) => field.onChange(target)}
                  onBlur={field.onBlur}
                  ref={field.ref}
                  styles={{ ...customSelectStyleNew(theme) }}
                />
              )}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md="6">
            <Label>LLM</Label>
            <Select
              value={selectedProvider}
              options={providerOptions}
              isSearchable={false}
              placeholder="Select LLM"
              onChange={(val) => { setSelectedProvider(val); setSelectedModel(null); }}
              styles={{ ...customSelectStyleNew(theme) }}
            />
          </Col>
          <Col md="6">
            <Label>Model</Label>
            <Select
              value={selectedModel}
              options={modelOptions}
              isSearchable={false}
              isDisabled={!selectedProvider}
              placeholder="Select Model"
              onChange={(val) => setSelectedModel(val)}
              styles={{ ...customSelectStyleNew(theme) }}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md="12">
            <Label>Description</Label>
            <input
              className="form-control"
              placeholder="Brief description of this prompt"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Col>
        </Row>

        <div className="w-100 d-flex flex-wrap mt-2 position-relative">
          {copied && (
            <span className="badge badge-main badge-warning">Copied</span>
          )}
          {gptTemplateTagsArray?.map((item: string, index) => (
            <span
              className="steps-tags-template"
              onClick={() => onCopyText(item)}
              id={`items-${index}`}
              key={index}
            >
              {item.split(', ')}
            </span>
          ))}
        </div>

        <Row>
          <Col md="12">
            <Label>Prompt Template</Label>
            <Controller
              control={control}
              name="template"
              rules={{ required: { value: true, message: 'Template is required' } }}
              render={({ field }) => (
                <textarea
                  name="template"
                  placeholder="Please add template"
                  rows={10}
                  className="form-control"
                  value={field.value ?? ''}
                  onChange={(e) => field.onChange(e.target.value)}
                  onBlur={field.onBlur}
                  ref={field.ref}
                />
              )}
            />
          </Col>
        </Row>

        <div className="d-flex align-items-center justify-content-end mt-5">
          <button
            type="button"
            className="buttonGenericStyle buttonPrimary"
            onClick={() => onClose()}
          >
            {CANCEL}
          </button>
          <div className="px-3" />
          <CustomButton
            buttonClick={handleSubmit(submitData)}
            className="buttonPrimary filledButton"
            loading={saveChatgptTemplatesLoading}
            disabled={saveChatgptTemplatesLoading}
            buttonText={SAVE}
          />
        </div>
      </Form>
    </div>
  );
};

export default AddModal;
